module.exports = __webpack_public_path__ + "static/media/jumo_wtrans.e50a2e9e.pdf";